import { Cards } from "../../../../shared/components/cards-engine/components/card/models/card.model";
import { CardUtils } from "../../../../shared/components/cards-engine/components/card/utils/card.utils";
import { CardsCatalog } from "../../../models/catalog.model";

export class EncounterUtils {
  static getVillainsCards(
    mainSchemeVillain: string[], // les tags ENCOUNTER avec le même tag VILLAIN
    sideSchemes: string[], // les tags ENCOUNTER sans le tag VILLAIN
    champions: string[]
  ) {
    const villainDeck = () => {
      let result = [];
      const deckCards = Object.values(CardsCatalog).filter(
        card =>
          // villains other cards
          !card.metadatas.tags.includes("MAINSCHEME") &&
          ((card.metadatas['targetName'] === mainSchemeVillain &&
            card.metadatas.tags.includes("ENCOUNTER") &&
            !card.metadatas.tags.includes("VILLAIN")) ||
            // encounters others modules
            (sideSchemes.includes(card.metadatas['targetName']) &&
              card.metadatas.tags.includes("ENCOUNTER")))
      );
      deckCards.forEach(card => {
        if (card.metadatas['required']) {
          for (let i = 0; i < card.metadatas['required']; i++) {
            result.push(card);
          }
        } else {
          result.push(card);
        }
      });
      return result;
    };

    const villainSchemes = () => {
      let result = [];
      const deckCards = Object.values(CardsCatalog).filter(
        card =>
          card.metadatas['targetName'] === mainSchemeVillain &&
          card.metadatas.tags.includes("ENCOUNTER") &&
          card.metadatas.tags.includes("MAINSCHEME")
      );
      deckCards.forEach(card => {
        if (card.metadatas['required']) {
          for (let i = 0; i < card.metadatas['required']; i++) {
            result.push(card);
          }
        } else {
          result.push(card);
        }
      });
      return result;
    };

    const villainVillains = () => {
      let result = [];
      const deckCards = Object.values(CardsCatalog).filter(
        card =>
          card.metadatas['targetName'] === mainSchemeVillain &&
          card.metadatas.tags.includes("ENCOUNTER") &&
          card.metadatas.tags.includes("VILLAIN")
      );
      deckCards.forEach(card => {
        if (card.metadatas['required']) {
          for (let i = 0; i < card.metadatas['required']; i++) {
            result.push(card);
          }
        } else {
          result.push(card);
        }
      });
      return result;
    };

    const villainNemesis = () => {
      let result = [];
      const deckCards = Object.values(CardsCatalog).filter(
        card =>
          champions.includes(card.metadatas['targetName']) &&
          card.metadatas['nemesis']
      );
      deckCards.forEach(card => {
        if (card.metadatas['required']) {
          for (let i = 0; i < card.metadatas['required']; i++) {
            result.push(card);
          }
        } else {
          result.push(card);
        }
      });
      return result;
    };

    const defaultBoxCards = defaultBox => {
      let result = [];
      const deckCards = Object.values(CardsCatalog).filter(
        card => card.metadatas['defaultBox'] === defaultBox
      );
      deckCards.forEach(card => {
        if (card.metadatas['required']) {
          for (let i = 0; i < card.metadatas['required']; i++) {
            result.push(card);
          }
        } else {
          result.push(card);
        }
      });
      return result;
    };

    let cards = {
      discard: [],
      deck: [...defaultBoxCards("DECK"), ...villainDeck()],
      schemes: villainSchemes(),
      villains: [...defaultBoxCards("VILLAINS"), ...villainVillains()],
      upgrades: [],
      minions: [],
      purge: [],
      nemesis: villainNemesis(),
      reveals: defaultBoxCards("REVEALS"), // keyforge
      archives: [] // keyforge
    };

    const cardsWithGeneratedId: Cards = CardUtils.generateCardsId(cards);
    return cardsWithGeneratedId;
  }

  static getEncounterCategoriesWithoutVillains() {
    let result = [];
    Object.values(CardsCatalog).forEach(card => {
      if (
        !result.includes(card.metadatas['targetName']) &&
        card.metadatas.tags.includes("ENCOUNTER_CATEGORY_WITHOUT_VILLAIN") &&
        !card.metadatas['nemesis']
      ) {
        result.push(card.metadatas['targetName']);
      }
    });
    return result;
  }
}
